import React, { useRef } from 'react';
import type { EmojiProvider } from '@atlaskit/emoji';
import { getEmojiProvider } from '@atlassian/jira-common-atlaskit-services/src/emoji.tsx';
import type { FieldOperations } from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import type { FieldConfigurationComponentProps } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types.tsx';
import { MultilineView } from './main.tsx';

export const MultilineFieldConfiguration = (props: FieldConfigurationComponentProps) => {
	const emojiProvider = useRef<Promise<EmojiProvider> | undefined>(getEmojiProvider() ?? undefined);

	return (
		<MultilineView {...props} mentionProvider={undefined} emojiProvider={emojiProvider.current} />
	);
};

export const isExpandable = (operations: FieldOperations): boolean =>
	operations.canModifyDefaultValue;
